export type ComponentUsageErrorCode = 'detached_root' | 'empty_render' | 'invalid_attribute_name' | 'invalid_layout_tag' | 'missing_option' | 'missing_part' | 'outside_provider' | 'route_render_failed' | 'route_unmatched' | 'route_without_default_export';

export class ComponentUsageError extends Error {
  constructor(
    readonly code: ComponentUsageErrorCode,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'ComponentUsageError';
  }
}
